import { RequestStatus } from '@upright/ui/api/common/types';
import { toSourceDescriptionTooltipText } from '@upright/ui/common/upright/core/impact-lenses/pais/source-description/tooltip';
import { useTaxonomyLensContext } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/common/use-taxonomy-lens-context';
import { KBUrl } from '@upright/ui/common/upright/kb-urls';
import { chain, values } from 'lodash';
import Skeleton from 'react-loading-skeleton';

export function TaxonomyLensSourceTooltipContent() {
  const ctx = useTaxonomyLensContext();
  if (!ctx) {
    return <></>;
  }
  const data = ctx.data;
  if (data.loadingStatus === RequestStatus.LOADING) {
    return <Skeleton width="5.0em" />;
  }
  const kpis = data.taxonomyKpis;
  if (!kpis) {
    return <>Error</>;
  }
  const datums = chain(kpis)
    .mapValues(byAct => values(byAct))
    .values()
    .flatten()
    .compact()
    .value();
  return (
    <>
      {toSourceDescriptionTooltipText(
        datums.filter(d => d.eligibility !== null).map(d => d.eligibility!),
        KBUrl.METHODOLOGY_TAXONOMY,
      )}
    </>
  );
}
